import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_LOGAPI, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_LOGAPI = 'GET_LIST_LOGAPI';

export const getLogApi = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_LOGAPI);

    axios({
      method: 'get',
      url: GET_LOGAPI,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_LOGAPI, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_LOGAPI,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_LOGAPI, 'error');
        alert(error);
      });
  };
};
